import art from '../images/art.png';
import about from '../images/about.png';
function Art() {
  return (
    <div className='Home'>
        <h1>Art Page Soon...</h1>
        <img src={about} />
    </div>
  );
}

export default Art;
